import { createI18n } from 'vue-i18n'
import en from './lang/en.json'
import vi from './lang/vi.json'

export default createI18n({
    legacy: true, // you must set `false`, to use Composition API
    locale: localStorage.getItem('lang') || 'vi',
    fallbackLocale: 'en', // set fallback locale
    messages: {
        vi,
        en
    }
})
